import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { MatDialogModule, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { LocalizationService } from '../../services/localization.service';
import { TarifaDetallesService } from '../../services/tarifa-detalles.service';
import { TipoInmuebleService } from '../../services/tipo-inmueble.service';
import { TarifaDetalleModel } from '../../models/TarifaDetalleModel';

@Component({
  providers: [TipoInmuebleService],
  selector: 'app-tarifa-detalle-edit',
  templateUrl: './tarifa-detalle-edit.component.html',
  styleUrls: ['./tarifa-detalle-edit.component.scss']
})
export class TarifaDetalleEditComponent implements OnInit {

  tarifaDetalleForm: FormGroup;
  title: string = "Crear";
  isNewElement: boolean;

  id: number;
  tarifaId: number;
  isModal: boolean;
  errorMessage: any;

  localization: LocalizationService;


  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute,
    private _TarifaDetalleService: TarifaDetallesService, private _authService: AuthService, private _router: Router,
    public dialogRef: MatDialogRef<TarifaDetalleEditComponent>,
    private _location: Location, localization: LocalizationService, public _TipoInmuebleService: TipoInmuebleService) {

    this.localization = localization;

    if (this._avRoute.snapshot.params["id"]) {
      this.id = this._avRoute.snapshot.params["id"];
    }

    this.tarifaDetalleForm = this._fb.group({
      id: 0,
      tarifaId: [''],
      tipoCalculo: ['', Validators.required],
      importeFijo: [''],
      porcentaje: [''],
      elemento: ['', Validators.required],
      max: [''],
      min: ['']
    });
  }

  disableCheck() {
    if (this.tarifaDetalleForm.get('tipoCalculo').value == 1) {
      this.tarifaDetalleForm.get('importeFijo').enable();
      this.tarifaDetalleForm.get('porcentaje').disable();
      this.tarifaDetalleForm.get('max').disable();
      this.tarifaDetalleForm.get('min').disable();
    }
    else {
      this.tarifaDetalleForm.get('importeFijo').disable();
      this.tarifaDetalleForm.get('porcentaje').enable();
      this.tarifaDetalleForm.get('max').enable();
      this.tarifaDetalleForm.get('min').enable();
    }
  }

  ngOnInit() {

    if (this.id > 0) {
      this.isNewElement = false;
      this.title = "Editar";
      this._TarifaDetalleService.getTarifaById(this.id)
        .subscribe(resp => {
          this.tarifaDetalleForm.setValue(resp);
          this.disableCheck();
        }
          , error => {
            this.errorMessage = error;
          });
    }
    else {
      this.tarifaDetalleForm.get('tarifaId').setValue(this.tarifaId);
      this.isNewElement = true;
      this.disableCheck();
    }

  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal)
      this._location.back();
    else
      this.closeDialog();
  }

  save() {
    if (!this.tarifaDetalleForm.valid) {
      return;
    }

    if (this.isNewElement) {
      this._TarifaDetalleService.createTarifaDetalle(this.tarifaDetalleForm.value)
        .subscribe((data) => {
          if (!this.isModal)
            this._location.back();
          else
            this.closeDialog();
        }, error => this.errorMessage = error)
    }
    else {
      this._TarifaDetalleService.updateTarifaDetalle(this.tarifaDetalleForm.value)
        .subscribe((data) => {
          if (!this.isModal)
            this._location.back();
          else
            this.closeDialog();
        }, error => this.errorMessage = error)
    }
  }

  get tipoCalculo() { return this.tarifaDetalleForm.get('tipoCalculo'); }
  get tipoInmuebleId() { return this.tarifaDetalleForm.get('tipoInmuebleId'); }
}
